export default "__VITE_ASSET__C6R1GraW__"